import { cn } from '@/lib/utils'

const SIZES = {
  /** The profile header: a 32 px tile in a 40 px chip. */
  profile: { tile: 'h-8 min-w-8 max-w-14', image: 'max-h-7 max-w-12' },
  /** The House selector (editing, onboarding): a 28 px tile in a 40 px chip. */
  picker: { tile: 'h-7 min-w-7 max-w-14', image: 'max-h-6 max-w-12' },
} as const

/**
 * A school's crest or flag on a white tile, so a dark mark does not vanish on
 * the dark theme. Fits inside the tile (a wide flag is never cropped, up to
 * 56 px of tile) and has an empty `alt`: the name beside it is the accessible
 * name, read once.
 */
export function Crest({
  src,
  size = 'profile',
  className,
}: {
  src: string
  size?: keyof typeof SIZES
  className?: string
}) {
  return (
    <span
      data-slot="crest"
      className={cn(
        'inline-grid shrink-0 place-items-center rounded-en-sm bg-en-tile px-1 shadow-[inset_0_0_0_1px_rgb(23_33_57/0.12)]',
        SIZES[size].tile,
        className
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- stored at its final size (96 px WebP) */}
      <img
        src={src}
        alt=""
        loading="lazy"
        decoding="async"
        className={cn('w-auto object-contain', SIZES[size].image)}
      />
    </span>
  )
}
